import { render, staticRenderFns } from "./VerifiedReviews.vue?vue&type=template&id=2a0b1f85&"
import script from "./VerifiedReviews.vue?vue&type=script&lang=js&"
export * from "./VerifiedReviews.vue?vue&type=script&lang=js&"
import style0 from "./VerifiedReviews.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports